// Only the dealer hand reaches the console. Thirteen slots fit the longest possible dealer hand;
// a card beyond the last slot would be dropped by `isUpdateDataValid`.
export enum BlackjackCardPosition {
    UpCard = 0,
    HoleCard = 1,
    DrawCard1 = 2,
    DrawCard2 = 3,
    DrawCard3 = 4,
    DrawCard4 = 5,
    DrawCard5 = 6,
    DrawCard6 = 7,
    DrawCard7 = 8,
    DrawCard8 = 9,
    DrawCard9 = 10,
    DrawCard10 = 11,
    DrawCard11 = 12
}

export enum BlackjackSidePosition {
    Dealer = 'dealer'
}

export interface BlackjackHandValues {
    dealerHandValue: number;
}
